__turbopack_context__.v({
  "contactStrip": "LogoStrip-module__aWuylW__contactStrip",
  "inverted": "LogoStrip-module__aWuylW__inverted",
  "label": "LogoStrip-module__aWuylW__label",
  "logo": "LogoStrip-module__aWuylW__logo",
  "logos": "LogoStrip-module__aWuylW__logos",
  "marquee": "LogoStrip-module__aWuylW__marquee",
  "note": "LogoStrip-module__aWuylW__note",
  "scroll": "LogoStrip-module__aWuylW__scroll",
  "strip": "LogoStrip-module__aWuylW__strip",
  "stripHeading": "LogoStrip-module__aWuylW__stripHeading",
  "track": "LogoStrip-module__aWuylW__track",
});
